<template>
  <v-card v-if="!full_screen_flg">
    <v-bottom-nav :active.sync="bottomNav" :value="true" app fixed shift>
      <template v-for="item in bottomItems">
        <v-btn
          color="secondary"
          flat
          :to="item.to"
          :value="item.value"
          :key="item.title"
          v-if="item.isShow"
        >
          <v-icon>{{ item.icon }}</v-icon>
        </v-btn>
      </template>
    </v-bottom-nav>
  </v-card>
</template>

<script>
import store from "@/store.js";

export default {
  name: "FooterNavigator",
  data() {
    return {
      full_screen_flg: store.state.full_screen_flg,
      bottomNav: "graph",
      bottomItems: [
        {
          to: "/",
          title: "home",
          icon: "fa-home",
          isShow: true
        },
        {
          to: "/create-graph",
          title: "graph",
          icon: "fa-chart-line",
          isShow: true
        },
        {
          to: "/mypage",
          title: "mypage",
          icon: "fa-user",
          isShow: store.state.twitter_account.is_login
        }
      ]
    };
  },
  computed: {
    /**
     * ログイン状態の変化を検知する
     */
    changeLoginStatus() {
      return store.state.twitter_account.is_login;
    },
    getFullScreenFlg() {
      return store.state.full_screen_flg;
    }
  },
  watch: {
    changeLoginStatus() {
      this.displayTwitterAcount();
    },
    getFullScreenFlg() {
      this.full_screen_flg = store.state.full_screen_flg;
    }
  },
  methods: {
    /**
     * ログイン状態が変わったら、マイページのアイコンを出す
     */
    displayTwitterAcount() {
      this.bottomItems[2].isShow = store.state.twitter_account.is_login;
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #6d6d6d;
}
</style>
